module.exports = __webpack_public_path__ + "img/kachel_aloevia_SUNCARE.2e40a021.png";